module.exports = __webpack_public_path__ + "img/logo_small.fb2e5bf5.png";